<template>
  <v-tooltip
    v-if="similarityLevel"
    right
    :color="similarityLevel === 'EXACT'
      ? 'error' : (
        similarityLevel === 'STRONG'
          ? 'warning' : (
            similarityLevel === 'WEAK'
              ? 'success' : ''
          )
      )"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        v-bind="attrs"
        v-on="on"
        v-if="similarityLevel === 'EXACT'"
        color="error"
      >
        mdi-signal-cellular-3
      </v-icon>
      <v-icon
        v-bind="attrs"
        v-on="on"
        v-else-if="similarityLevel === 'STRONG'"
        color="warning"
      >
        mdi-signal-cellular-2
      </v-icon>
      <v-icon
        v-bind="attrs"
        v-on="on"
        v-else-if="similarityLevel === 'WEAK'"
        color="success"
      >
        mdi-signal-cellular-1
      </v-icon>
      <v-icon v-else>
        signal-cellular-outline
      </v-icon>
    </template>
    <span v-if="similarityLevel === 'EXACT'">{{ $t('ewe_screen.entities_table.column.similarity.exact') }}</span>
    <span v-else-if="similarityLevel === 'STRONG'">{{ $t('ewe_screen.entities_table.column.similarity.strong') }}</span>
    <span v-else-if="similarityLevel === 'WEAK'">{{ $t('ewe_screen.entities_table.column.similarity.weak') }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    similarityLevel: {
      type: String,
      default: 'N/A'
    }
  }
}
</script>
